import { Box, Heading, HiddenVisually, Stack } from 'braid-design-system';

import { type Jobs } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { CompanyReviewAISummarySection } from '../../components/salaries/companyReviewAISummarySection/CompanyReviewAISummarySection';
import { OpenJobsSection } from '../../components/salaries/openJobsSection/OpenJobsSection';
import { SalariesListingSection } from '../../components/salaries/salariesListingSection/SalariesListingSection';
import { SalariesSearchSection } from '../../components/salaries/salariesSearchSection/SalariesSearchSection';
import { SalarySatisfactionSection } from '../../components/salaries/salarySatisfactionSection/SalarySatisfactionSection';
import translations from './.vocab';
import type { SalariesTabModel } from './salariesTabModel';

interface SalariesPageProps {
  getPaginatedJobs: (organisationId: string, page?: number) => Promise<Jobs>;
  model: SalariesTabModel;
  trackJobsPaginationClicked: ({
    searchTotalCount,
    pageNumber,
  }: {
    pageNumber: number;
    searchTotalCount?: number;
  }) => void;
}

export const SalariesPage = ({
  model,
  getPaginatedJobs,
  trackJobsPaginationClicked,
}: SalariesPageProps) => {
  const { t } = useTranslations(translations);
  const { companyName } = model;

  return (
    <>
      <HiddenVisually>
        <Heading level="1">{t('Company salaries', { companyName })}</Heading>
      </HiddenVisually>
      <Box paddingX={['none', 'gutter']} paddingTop="large">
        <Stack space={'xlarge'}>
          <SalariesSearchSection model={model} />
          <SalariesListingSection model={model} />
          {!!model.salarySatisfactionRating && (
            <SalarySatisfactionSection model={model} />
          )}
          {model.jobs && (
            <OpenJobsSection
              model={model}
              getPaginatedJobs={getPaginatedJobs}
              trackJobsPaginationClicked={trackJobsPaginationClicked}
            />
          )}
          {model.companyReviewsAISummary && (
            <CompanyReviewAISummarySection model={model} />
          )}
        </Stack>
      </Box>
    </>
  );
};
